import { Boolean } from "#/enums";

export const opcoesBoolean = [
  {
    label: "Sim",
    value: Boolean.TRUE,
  },
  {
    label: "Não",
    value: Boolean.FALSE,
  },
];
